// 개인정보 수집·이용 동의문: default text per language.
//
// The defaults live here (not in the DB): a study with no saved SFQ_ConsentTemplate row
// falls back to these, so changing the wording for new studies is a frontend-only change.
// Same arrangement as emailTemplates.js.
//
// Unlike the invitation mail there are no {{variables}} — the consent text is shown to the
// site exactly as authored, and adding a substitution pass would mean a placeholder could
// silently blank out part of a legal notice.
//
// Keep in step with DEFAULT_CONSENT_TEMPLATE in the API's services/Feasibility/consent.js,
// which is the fallback the server uses when it has to resolve the text without us.

export const CONSENT_TITLE_MAX = 300;

export const DEFAULT_CONSENT_TEMPLATES = {
  ko: {
    title: "개인정보 수집·이용 동의",
    bodyHtml: `<p>본 사전 타당성 조사(Feasibility Questionnaire) 응답을 위해 아래와 같이 개인정보를 수집·이용합니다. 내용을 확인하신 후 동의해 주시기 바랍니다.</p>
<h3>1. 수집하는 개인정보 항목</h3>
<p>기관명, 연구책임자(PI) 성명 및 이메일 주소, 연구간호사(CRC) 성명 및 이메일 주소, 응답자 이메일 주소, 응답 내용, 접속 일시 및 IP 주소</p>
<h3>2. 수집·이용 목적</h3>
<p>임상시험 실시기관 선정을 위한 사전 타당성 검토, 응답 내용 확인 및 담당자 연락, 임상시험 관련 법령 및 규정에 따른 기록 보존</p>
<h3>3. 보유 및 이용 기간</h3>
<p>수집일로부터 임상시험 종료 후 관계 법령에서 정한 기간(임상시험 관련 기록의 보존 기간)까지 보관하며, 기간 경과 후 지체 없이 파기합니다.</p>
<h3>4. 동의를 거부할 권리 및 거부에 따른 불이익</h3>
<p>귀하는 개인정보 수집·이용에 대한 동의를 거부하실 수 있습니다. 다만 동의하지 않으시는 경우 본 사전 타당성 조사에 응답하실 수 없습니다.</p>`,
  },
  en: {
    title: "Consent to Collection and Use of Personal Information",
    bodyHtml: `<p>To respond to this Feasibility Questionnaire, the following personal information is collected and used. Please review and provide your consent.</p>
<h3>1. Information collected</h3>
<p>Site name, Principal Investigator (PI) name and email address, Study Coordinator (CRC) name and email address, respondent email address, questionnaire responses, access date/time and IP address.</p>
<h3>2. Purpose of collection and use</h3>
<p>Feasibility assessment for clinical trial site selection, verification of responses and contact with the responsible personnel, and record retention as required by applicable clinical trial laws and regulations.</p>
<h3>3. Retention period</h3>
<p>Retained from the date of collection until the end of the retention period for clinical trial records prescribed by applicable law, and destroyed without delay thereafter.</p>
<h3>4. Right to refuse</h3>
<p>You may refuse to consent to the collection and use of your personal information. However, if you do not consent, you will not be able to respond to this questionnaire.</p>`,
  },
};

// The site page shows one of the two and records which one was on screen. A study is
// normally sent in one language, but the reader may prefer the other.
export const CONSENT_LANGS = [
  { key: "ko", label: "한국어" },
  { key: "en", label: "English" },
];
